<template>
  <j-error-alert
    v-if="error"
    v-model="error"
    v-on:retry="refetchData()"
  />
  <v-card
    v-else
    :loading="isLoading"
  >
    <v-skeleton-loader
      v-if="isLoading || !item"
      height="94"
      type="list-item-two-line"
    />
    <template v-else>
      <v-card-title>
        {{ item.date | long-date }}
      </v-card-title>
      <v-card-text>
        <div>Rating: {{ item.rating }}</div>
        <div>Failure: {{ item.failure }}</div>
        <div>Time: {{ item.timeGroup.name }}</div>
        <div>Type: {{ item.type.name }}</div>
        <div>Location: {{ item.location.name }}</div>
        <div v-if="item.place">Place: {{ item.place.name }}</div>
        <div>Positions: {{ item.positions.map(position => position.name).join(', ') }}</div>
      </v-card-text>
      <!-- <v-card-text>
        {{ item }}
      </v-card-text> -->

      <v-card-actions>
        <v-btn
          :to="{ name: 'item-edit', params: { itemId: itemId } }"
        >
          Edit
        </v-btn>
      </v-card-actions>
    </template>
  </v-card>
</template>

<script>
// import api from '@/helpers/api'
import JErrorAlert from '@/ui/controls/JErrorAlert'

export default {
  components: {
    JErrorAlert,
  },
  props: {
    itemId: [Number, String],
  },
  data() {
    return {
      item: undefined,
      isLoading: false,
      error: undefined,
    }
  },
  computed: {
    url() {  
      return this.$api.resolvePath(['items', this.itemId, 'details'])
    },
  },
  watch: {
    url: {
      immediate: true,
      handler(newVal) {
        this.fetchData(newVal)
      }
    },
  },
  methods: {
    refetchData() {
      this.fetchData(this.url)
    },
    fetchData(url) {
      this.isLoading = true
      this.error = undefined
      console.log('fetching:', url)
      // fetch(url)
      this.$api.get(url)
        .then(res => {
          console.log(res)
          return res
        })
        .then(res => res.json())
        .then(data => {
          this.item = data
        })
        .catch(err => {
          console.error(err)
          this.error = err
        })
        .finally(() => this.isLoading = false)
    }
  },
}
</script>